import { FieldValues, useController } from "react-hook-form";

import { TextAreaFieldProps, DefaultProps } from "../FormField";
import { Textarea } from "@/components/Forms";

type Props<T extends FieldValues> = Omit<
  DefaultProps<T> & TextAreaFieldProps,
  "type"
>;

const TextareaField = <T extends FieldValues>({
  name,
  control,
  ...rest
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return <Textarea $hasError={!!error} {...field} {...rest} />;
};

export default TextareaField;
